export const APP_RUNTIME_CONFIG = {
    cahchePrefix: 'sktv',
    isFlugb: false,
    ports: {
        socket: 3330,
        backoffice: 3335,
        poster: 3339,
        zoom: 3336,
        media: 3337,
        app: 3332,
        appuniv: 3331,
    }
};
